module.exports = __webpack_public_path__ + "img/map.0d812082.svg";